import Lottie from 'react-lottie';
import styled from 'styled-components';
import { device } from '../../../styles/device';

interface LottieConfigProps {
  animationData: object;
  customHeight: number;
  customWidth: number;
}

function LottieConfig({ animationData, customHeight, customWidth }: LottieConfigProps) {
  const Wrapper = styled.div`
    display: block;
    width: 100%;

    @media ${device.mobile} {
      width: 375px !important;
      height: 328px !important;
      margin-top: 50px;
      margin-left: 10px;
    }
  `;

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const width = customWidth !== undefined ? customWidth : window.screen.width > 450 ? 400 : 350;

  return (
    <Wrapper>
      <Lottie options={defaultOptions} height={customHeight || 400} width={width} />
    </Wrapper>
  );
}

export default LottieConfig;
